import { ChevronsUp } from 'react-feather'
import { Text } from 'rebass'
import styled from 'styled-components'

import { formatPercentage } from '../../utils/numbers'

const ApyValue = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.deprecated_green1};
`

interface ApyProps {
  apy: string | undefined
  show?: boolean
}

export function Apy({ apy, show = false }: ApyProps) {
  return (
    <ApyValue>
      <ChevronsUp size={14} style={{ marginRight: '4px' }} />
      <Text fontSize={12} color="#10b981">
        {formatPercentage(apy ?? '0')} APY
      </Text>
    </ApyValue>
  )
}
